module.exports = __webpack_public_path__ + "media/packs/images/update-icons/freight-f1e93de73bfbcb59e98613afdb2932a0.svg";